import _regeneratorRuntime from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import FirebaseNodeSanitizerInstance from "./FirebaseNodeSanitizer";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getDatabase, ref, onValue } from "firebase/database";

var FirebaseBaseSessionAsync = /*#__PURE__*/function () {
  function FirebaseBaseSessionAsync(id) {
    _classCallCheck(this, FirebaseBaseSessionAsync);

    this.id = id;
  }

  _createClass(FirebaseBaseSessionAsync, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(accessData, connectHandler) {
        var auth;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.firebaseSettings = {
                  prefix: accessData.firebasePrefix,
                  Url: accessData.firebaseUrl,
                  token: accessData.firebaseToken
                };
                this.firebaseSettings.config = JSON.parse(accessData.firebaseClientJson);
                this.firebaseApp = initializeApp(this.firebaseSettings.config, "firebaseApp:" + this.id);
                auth = getAuth(this.firebaseApp);
                _context.prev = 4;
                _context.next = 7;
                return signInWithCustomToken(auth, this.firebaseSettings.token);

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](4);
                throw _context.t0;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 9]]);
      }));

      function connect(_x, _x2) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "getReference",
    value: function getReference(baseNode, terminalNode) {
      var database = getDatabase(this.firebaseApp);
      return ref(database, "cs/" + baseNode + "/" + this.firebaseSettings.prefix + "/" + terminalNode);
    }
  }, {
    key: "getFirebaseApp",
    value: function getFirebaseApp() {
      return this.firebaseApp;
    }
  }, {
    key: "addNodeUpdateListener",
    value: function addNodeUpdateListener(baseNode, terminalNode, nodeUpdateListener) {
      var nodeReference = this.getReference(baseNode, FirebaseNodeSanitizerInstance.encodeKey(terminalNode));
      onValue(nodeReference, nodeUpdateListener);
    }
  }]);

  return FirebaseBaseSessionAsync;
}();

export { FirebaseBaseSessionAsync as default };